<template>
  <div class="email-create">
    <div class="box">
      <admin-box-item title="이메일 전송" subtitle="서비스 대표 계정으로 고객들에게 메일을 보낼 수 있습니다.">
        <div v-if="!$route.query.id">
          <admin-form-item label="전송 대상">
            <lp-radio :val.sync="value.target"
                      value_name="value"
                      label_name="label"
                      :data="[{label:'일반회원',value:0}, {label:'마케팅정보수신동의회원', value:2}]"></lp-radio>
          </admin-form-item>
          <admin-form-item label="메일제목">
            <input class="input"
                   v-model="value.title"
                   placeholder="제목을 입력하세요."
                   type="text">
          </admin-form-item>
          <admin-form-item label="메일내용">
            <lp-editor :text.sync="value.content"></lp-editor>
          </admin-form-item>
        </div>
        <div v-else>
          <admin-form-item label="전송 대상">
            {{ value.target===0?'전체회원':value.target===1?'일반회원':'마케팅수신동의회원' }}
          </admin-form-item>
          <admin-form-item label="메일제목">
            {{ value.title }}
          </admin-form-item>
          <admin-form-item label="메일내용">
            <div v-html="value.content"></div>
          </admin-form-item>
        </div>
      </admin-box-item>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end" v-if="!$route.query.id">
      <button class="button is-primary" @click="sendValidCheck">전송</button>
    </div>

    <modal name="sendModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">메세지를 전송하시겠습니까?</div>
        <div class="flex-center">
          <button class="button is-primary" @click="saveData">예(Y)</button>
          <button class="button"
                  style="background-color:#A0A0A0;color:white;margin-left:12px"
                  @click="$modal.hide('sendModal')">아니요(N)</button>
        </div>
      </div>
    </modal>

    <modal name="sendConfirmModal" :adaptive="true" :width="400" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div style="text-align: center;padding:36px">메세지가 고객에게 발송되었습니다.</div>
        <div class="flex-center">
          <button class="button is-primary" @click="hideConfirmModal">확인</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
  import LpRadio from "../../module/common/LpRadio";

  export default {
    name: "EmailCreate",
    components: {LpRadio},
    created() {
      this.getData();
    },
    data() {
      return {
        value: {
          target: 0,
          title: '',
          content: '',
        },
      }
    },
    watch: {
    },
    methods: {
      inputMsg(e) {
        this.value.msg = e.target.value;
        this.bytes = this.getByte(e.target.value);
      },
      getByte(str) {
        return str
          .split('')
          .map(s => s.charCodeAt(0))
          .reduce((prev, c) => (prev + ((c === 10) ? 2 : ((c >> 7) ? 2 : 1))), 0);
      },
      sendValidCheck() {
        if(!this.value.title) {
          this.toast('메일제목을 입력하세요.');
          return;
        }
        if(!this.value.content) {
          this.toast('메일내용을 입력하세요.');
          return;
        }
        this.$modal.show('sendModal');
      },
      saveData() {
        let url = 'admin/email/send/multiple';
        this.$axios.post(url, this.value).then(res => {
          this.$modal.hide('sendModal');
          this.$modal.show('sendConfirmModal');
        }).catch(error => {
          this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
        })
      },
      hideConfirmModal() {
        this.$modal.hide('sendConfirmModal');
        this.$router.replace(this.getPath('email'));
      },
      getData() {
        if(!this.$route.query.id) return;
        let url = `admin/email/send/multiple/${this.$route.query.id}`;
        this.$axios.get(url).then(res => {
          this.value = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
  .sms-textarea-wrapper
    border 1px solid #ddd
    border-radius 4px
    padding 6px

  .sms-textarea
    border 0
    box-shadow none
    padding 0
    resize none
</style>
<style lang="stylus">
  .email-create .content figure
    text-align left
</style>
